/**
 * @generated SignedSource<<5f2443967b75e3395e32b5e80f6cee22>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountFeatureId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeatureFlagDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAccountFeatureTPayload",
        "kind": "LinkedField",
        "name": "deleteAccountFeatureTByAccountFeatureId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountFeatureT",
            "kind": "LinkedField",
            "name": "accountFeatureT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeatureFlagDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteAccountFeatureTPayload",
        "kind": "LinkedField",
        "name": "deleteAccountFeatureTByAccountFeatureId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountFeatureT",
            "kind": "LinkedField",
            "name": "accountFeatureT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "12f4bec5fcef8116d2ed5a7bd1c17757",
    "id": null,
    "metadata": {},
    "name": "FeatureFlagDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FeatureFlagDeleteMutation(\n  $input: DeleteAccountFeatureTByAccountFeatureIdInput!\n) {\n  deleteAccountFeatureTByAccountFeatureId(input: $input) {\n    accountFeatureT {\n      accountFeatureId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "ed8d742b59b3f15fc9d14a9e88c13e80";

module.exports = node;
